const ENDPOINT = "https://api.web3forms.com/submit";

export const submitToWeb3Forms = async (
  subject: string,
  fields: Record<string, string>,
): Promise<boolean> => {
  const accessKey = (import.meta as any).env?.VITE_WEB3FORMS_KEY;
  if (!accessKey) return false;

  try {
    const response = await fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        access_key: accessKey,
        subject,
        from_name: "The Stables Website",
        ...fields,
      }),
    });
    const result = await response.json();
    return response.ok && result.success === true;
  } catch {
    return false;
  }
};
